import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resolveStripeCancelPath } from '../constants/urls';
import { initiateCheckout } from '../utils/checkout';
import './Checkout.css';

const Checkout: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const cancelParam = searchParams.get('cancel');

  useEffect(() => {
    const startCheckout = async () => {
      const fallback = resolveStripeCancelPath(cancelParam);
      try {
        setIsLoading(true);
        await initiateCheckout('pro', {
          cancelPath: cancelParam,
          source: 'checkout_route',
        });
      } catch (error) {
        console.error('Checkout failed:', error);
        window.location.replace(
          `${window.location.origin}${fallback}`
        );
      }
    };

    startCheckout();
  }, [cancelParam]);

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        {isLoading && (
          <div className="checkout-loading">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Checkout;
